export class CfgDeveloperSetting {
  numberOfFintractId: number;
  developerFromName: string;
  backgroundImage: string;
  pdfPageHeight: number;
  pdfPageWidth: number;
  crmLeadEnabled: boolean;

  userProfileQuestions: string;
  developerFromEmail: string;
  pdfEditBorderWidth: number;
  crmType: string;

  constructor(data: any) {
    this.numberOfFintractId = data.numberOfFintractId === null || isNaN(data.numberOfFintractId) ? 1 : Number(data.numberOfFintractId);
    this.developerFromName = data.developerFromName;
    this.backgroundImage = data.backgroundImage;
    this.pdfPageHeight = data.pdfPageHeight == null || isNaN(data.pdfPageHeight) ? 1053 : Number(data.pdfPageHeight);
    this.pdfPageWidth = data.pdfPageWidth == null || isNaN(data.pdfPageWidth) ? 813 : Number(data.pdfPageWidth);
    this.crmLeadEnabled = data.crmLeadEnabled == null || isNaN(data.crmLeadEnabled) ? false : data.crmLeadEnabled;

    this.userProfileQuestions = data.userProfileQuestions;
    this.developerFromName = data.developerFromName;
    this.developerFromEmail = data.developerFromEmail;
    this.pdfEditBorderWidth = data.pdfEditBorderWidth;
    this.crmType = data.crmType;
  }
}